export default __webpack_public_path__ + "media/zurb/img/growth-design/lead-gen-stats-7ff4897f6394992870efde4d4d8c32d9.png";